import React, { Component } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import proj from 'ol/proj';

import { Map } from '../ol';

const DEFAULT_CENTER = [36.45923015624996, 43.413130671534105];
const DEFAULT_ZOOM = 3;

class MapWithRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zoom: DEFAULT_ZOOM,
      center: DEFAULT_CENTER
    }

    this.setLocationFromUrl = this.setLocationFromUrl.bind(this);
    this.onMoveEnd = this.onMoveEnd.bind(this);
    this.zoomToExtent = this.zoomToExtent.bind(this);
  }

  componentWillMount() {
    this.setLocationFromUrl();
  }

  setLocationFromUrl() {
    const { location } = this.props;
    const { zoom, lat, lon } = queryString.parse(location.search)

    let center;
    if(lat && lon) {
      center = proj.fromLonLat([parseFloat(lon), parseFloat(lat)], 'EPSG:3857');
    } else {
      center = proj.fromLonLat(DEFAULT_CENTER, 'EPSG:3857');
    }

    this.setState({
      center,
      zoom: zoom || DEFAULT_ZOOM
    })
  }

  // where to move this to?
  zoomToExtent(extent) {
    this.refs.map.zoomToExtent(extent);
  }

  onMoveEnd(e) {
    const { history } = this.props;
    let center = e.map.getView().getCenter();
    center = proj.toLonLat([parseFloat(center[0]), parseFloat(center[1])], 'EPSG:3857');

    const zoom = e.map.getView().getZoom();
    history.replace({ search: `?lat=${center[1]}&lon=${center[0]}&zoom=${zoom}`});
  }

  render() {
    const { children } = this.props;
    const { zoom, center } = this.state;

    return (
      <Map ref="map" {...this.props} zoom={zoom} center={center} onMoveEnd={this.onMoveEnd}>
        {children}
      </Map>
    )
  }
}

export default MapWithRouter;



// WEBPACK FOOTER //
// ./src/components/containers/MapWithRouter.js